const ActionApiMethodType = [
    {
        value : 'get',
        text : <span className="get-method">GET</span>
    },
    {
        value : 'post',
        text : <span className="post-method">POST</span>
    },
    {
        value : 'put',
        text : <span className="put-method">PUT</span>
    },
    {
        value : 'delete',
        text : <span className="delete-method">DELETE</span>
    },
    {
        value : 'patch',
        text : <span className="patch-method">PATCH</span>
    },
]

export default ActionApiMethodType;